import { Box, Button, /*Button,*/ Typography, Tooltip } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import { Create, RadioButtonChecked } from "@material-ui/icons";
// import DragHandle from "@material-ui/icons/DragHandle";
import classNames from "classnames";
import update from "immutability-helper";
// import range from "lodash/range";
import React from "react";
import { Prompt, Link } from "react-router-dom";
import { SortEnd, arrayMove } from "react-sortable-hoc";
import Component from "src/components/Component";
import Page from "src/components/Page";
import PartialCleanCheck from "src/components/PartialCleanCheck";
// import RadioScale from "src/components/RadioScale";
import SortableList from "src/components/SortableList";
import withAxios from "src/components/withAxios";
import { IUser } from "src/services";
// import { Link } from "react-router-dom";
import html2pdf from 'html2pdf.js';
import {
  ITemplate,
  ITemplateData,
  ITemplateDirectorRequest2,
  ITemplateQuestion,
  TemplateQuestionCategory,
  TemplateQuestionType,
  TemplateQuestionUtil,
} from "src/services";
import { SaveButton, TemplateSettings } from "./components";
import {
  ATHLETE_COLUMN_HEADING,
  COACH_COLUMN_HEADING,
  EXPECTATIONS_QUESTIONS_HEADING,
  GET_TEMPLATE_PAGE_SUBTITLE,
  PARENT_QUESTIONS_HEADING,
  PRINT_BUTTON_LABEL,
  // PRINT_BUTTON_LABEL,
  TEMPLATE_PAGE_HEADER,
  UNSAVED_CHANGES_PROMPT,
  WARMTH_QUESTIONS_HEADING,
  WRITTEN_QUESTIONS_HEADING,
} from "./constants";
import { styles } from "./styles";
import Modal from "src/components/Modal";
import { IProps, ITemplateEditorState, ITemplateQuestionEdit } from "./types";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import SurveyPrinter, {
//   PrintSurveyFunc,
// } from "src/pages/director/survey/SurveyPrinter";



export const noneIdValue = "none";

const AthleteCoachHeading = ({
  classes,
  isEditorMode,
  isAdSurvey 
}: {
  classes: ClassNameMap<string>;
  isEditorMode: boolean;
  isAdSurvey:boolean;
}) => (
  <Box
    className={classes.columnHeadingsWrapper}
    marginLeft={!isEditorMode ? "3rem" : "8px"}
    width={!isEditorMode ? "96%" : "92%"}
  >
    <Typography className="athlete-head" variant="h6">
      {isAdSurvey === true ? "Coach": ATHLETE_COLUMN_HEADING}
    </Typography>
    <Typography className="coach-head" variant="h6">
      {isAdSurvey === true ? "AD": COACH_COLUMN_HEADING
      }</Typography>
  </Box>
);

export default withStyles(styles)(
  withAxios(
    class TemplateEditorPage extends Component<IProps, ITemplateEditorState> {
      private handleNameChange = this.stateInputEventHandler((v) => ({
        name: v,
      }));

      private handleDefaultPositiveTextChange = this.stateTextAreaEventHandler(
        (v) => ({ defaultPositiveText: v })
      );

      private handleDefaultNegativeTextChange = this.stateTextAreaEventHandler(
        (v) => ({ defaultNegativeText: v })
      );

      // private printEvaluation?: PrintSurveyFunc;
      private newQuestionRef = React.createRef<HTMLTextAreaElement>();
      private partialCleanCheck: PartialCleanCheck<ITemplateEditorState> =
        new PartialCleanCheck(this, [
          "name",
          "parentId",
          "questions",
          "defaultPositiveText",
          "defaultNegativeText",
          "defaultReversed",
          "defaultScale",
          "enableParentQuestions",
          "templateType",
        ]);

      // private DragHandle = SortableHandle(() => <DragHandle />);
      private questionLocalId = 0; // Keeps track of how many questions we have so that we always have a unique id

      constructor(props: IProps) {
        super(props);
        this.state = {
          copyId: null,
          defaultNegativeText: "Strongly\nDisagree",
          defaultPositiveText: `Strongly\nAgree`,
          defaultReversed: false,
          defaultScale: 7,
          enableParentQuestions: false,
          name: "",
          parentId: null,
          parentQuestions: [],
          questions: [],
          scalePreview: "",
          showPrintButton: false,
          showScaleOptions: false,
          templateType: 0,
          templates: [],
          ...(this.state as any),
          modalVisible: false,
          isGeneratingPDF: false,
          school: "",
          userSubscription: "" as any,
          isMeadSeason:false,
          schoolData:""
        };
        this.partialCleanCheck.setOldFormData(this.state);
      }
      
      public componentDidMount = async () => {
        const { schoolId } = this.props;
        this.loadUserSubscription(schoolId);
        this.loadTemplate(this.props.templateId);
         const midSeasonCheckin: any = await this.buildGet<IUser>(this, `/school/getOneSchools/${schoolId}`)()
                  console.log("midSeasonCheckin::::::::::::::::", midSeasonCheckin )
                  this.setState({ schoolData:
                    midSeasonCheckin?.data
                  })
        // this.loadInheritTemplates();
         const res: any = await this.buildGet<IUser>(this, "user")()
        const hhheadcoch = await this.buildPost<{ userId: any, schoolId: any }, any>(
          this,"/coaches/getHeadCoach"
        )({
          userId: res?.id,
          schoolId: this.props?.schoolId

        });
        console.log("Mideseson res:::", hhheadcoch)
        if((hhheadcoch?.data?.type === "head" || "coach") && hhheadcoch?.data !== null){
        this.setState({
          isMeadSeason: true
        })
      }

      }

  
     public generatePDF = () => {
        this.setState((prevState) => ({
          ...(prevState as any), // Type assertion to bypass type checking
          isGeneratingPDF: true,    // Set modalVisible to true to open the modal
        }));
        setTimeout(() => {
          this.setState((prevState) => ({
            ...(prevState as any), // Type assertion to bypass type checking
            isGeneratingPDF: false,    // Set modalVisible to true to open the modal
          })); // Reset state after 1 second
        }, 1000); // 1000 milliseconds = 1 second
     
        const element = document.getElementById('pdfContent');
        const options = {
          margin: [2, 1],// Set margins to zero or adjust as needed
          filename: 'document.pdf',
          image: { type: 'jpeg', quality: 1.00 },
          html2canvas: { scale: 3.0, logging: true }, // Enable logging for debugging
          jsPDF: { format: 'a3', orientation: 'portrait' },
          pagebreak: { mode: ['css', 'legacy'], before: '.page-break-before', after: '.page-break-after', avoid: '.no-page-break' }

        };

        // Generate the PDF using html2pdf.js but do not download directly
        html2pdf().from(element).set(options).outputPdf('blob').then((pdfBlob: Blob) => {
          // Create a Blob URL for the PDF
          const pdfURL = URL.createObjectURL(pdfBlob);
          // Open the PDF in a new tab
          window.open(pdfURL);
        });
      };



      // public generatePDF = () => {
      //   this.setState((prevState) => ({
      //     ...(prevState as any), // Type assertion to bypass type checking
      //     isGeneratingPDF: true,    // Set modalVisible to true to open the modal
      //   }));
      //   setTimeout(() => {
      //     this.setState((prevState) => ({
      //       ...(prevState as any), // Type assertion to bypass type checking
      //       isGeneratingPDF: false,    // Set modalVisible to true to open the modal
      //     })); // Reset state after 1 second
      //   }, 1000); // 1000 milliseconds = 1 second
     
      //   const element = document.getElementById('pdfContent');
      //   const options = {
      //     margin: [2, 1],// Set margins to zero or adjust as needed
      //     filename: 'document.pdf',
      //     image: { type: 'jpeg', quality: 1.00 },
      //     html2canvas: { scale: 3.0, logging: true }, // Enable logging for debugging
      //     jsPDF: { format: 'a3', orientation: 'portrait' },
      //     pagebreak: { mode: ['avoid-all'] } // Adjust page break settings
      //     // pagebreak: { mode: ['css', 'legacy'] } // Use CSS page break mode

      //   };

      //   // Generate the PDF using html2pdf.js but do not download directly
      //   html2pdf().from(element).set(options).outputPdf('blob').then((pdfBlob: Blob) => {
      //     // Create a Blob URL for the PDF
      //     const pdfURL = URL.createObjectURL(pdfBlob);
      //     // Open the PDF in a new tab
      //     window.open(pdfURL);
      //   });
      // };


      public checkCustomizableAddonAndRedirect = () => {
        const { templateId, schoolSlug } = this.props;
        const userSubscription = (this.state as any).userSubscription;
      
        // Check if the plan is Elite, Premier, or Pro
        const validPlans = [3, 4, 5];
        const isValidPlan = userSubscription?.plans && validPlans.includes(userSubscription?.plans?.id);
      
        // Check if the plan is free (assuming free plan ID is 1)
        const isFreePlan = userSubscription?.plans && userSubscription?.plans?.id === 1;
        // Map through add-ons to check for "Customizable Questions"
        const customizableAddon = userSubscription.addon?.find(
          (addonItem: any) => addonItem.addon?.id === 1
        );
      
        // If the add-on is found or the plan is valid, redirect to the Edit Template page
        if (customizableAddon || isValidPlan) {
          this.props.history.push(`/${schoolSlug}/edit-template/${templateId}`);
        } else {
          // Create a custom confirmation dialog
          const confirmationDialog = document.createElement('div');
          confirmationDialog.innerHTML = `
            <div style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              justify-content: center;
              align-items: center;
            ">
              <div style="
                background: white;
                padding: 20px;
                border-radius: 8px;
                text-align: center;
                width: 400px;
                 
              ">
                <p
                style="
                   font-size: 18px;
                font-weight: 500;
                 
              ">You need to  have an eligible plan (Elite) to enable editing.
 </p>
                <div style="padding-top:30px;"><button id="upgradeBtn" style="
                  margin-right: 30px;
                  padding: 8px 16px;
                  background-color: #484b8f;
                  color: white;
                  border: none;
                  border-radius: 4px;
                  cursor: pointer;
                ">Upgrade</button>
                <button id="cancelBtn" style="
                  padding: 8px 16px;
                  background-color: #6c757d;
                  color: white;
                  border: none;
                  border-radius: 4px;
                  cursor: pointer;
                ">Cancel</button>
              </div>
              </div>
            </div>
          `;
      
          document.body.appendChild(confirmationDialog);
      
          // Add event listeners to buttons
          document.getElementById('upgradeBtn')?.addEventListener('click', () => {
            const upgradeUrl = isFreePlan 
              ?  `/${schoolSlug}/upgrade-subscription` :
              `/${schoolSlug}/subscription-history` ;
            window.open(upgradeUrl, '_blank');
            document.body.removeChild(confirmationDialog); // Remove the dialog
          });
      
          document.getElementById('cancelBtn')?.addEventListener('click', () => {
            document.body.removeChild(confirmationDialog); // Remove the dialog
          });
        }
      };
      
      public render() {
        const { classes, isEditorMode, templateId, schoolSlug } = this.props;
        const {
          name,
          loading,
          parentId,
          copyId,
          defaultPositiveText,
          defaultNegativeText,
          defaultReversed,
          defaultScale,
          enableParentQuestions,
          parentQuestions,
          postingTemplate,
          questions,
          scalePreview,
          submitting,
          templates,
          templateType,
          isMeadSeason
        } = this.state;
        const modalVisible = (this.state as any).modalVisible;
        const isGeneratingPDF = (this.state as any).isGeneratingPDF;
        const school = (this.state as any).school;
        const parentTemplate = !(
          templateId === undefined ||
          templates.findIndex(
            (template) => template.parentId === templateId
          ) === -1
        );

        const questionsToRender = (
          isEditorMode ? questions : parentQuestions
        ) as ITemplateQuestionEdit[];

        const expectationsQuestions = this.getQuestionCategory(
          TemplateQuestionCategory.expectations,
          questionsToRender
        );
        const warmthQuestions = this.getQuestionCategory(
          TemplateQuestionCategory.warmth,
          questionsToRender
        );
        const otherQuestions = this.getQuestionCategory(
          TemplateQuestionCategory.other,
          questionsToRender
        );
        const parentCategoryQuestions = this.getQuestionCategory(
          TemplateQuestionCategory.parent,
          questionsToRender
        );

        const hasExpectationsQuestions = expectationsQuestions.length > 0;
        const hasWarmthQuestions = warmthQuestions.length > 0;
        const hasOtherQuestions = otherQuestions.length > 0;
        const hasParentQuestions = parentCategoryQuestions.length > 0;


        window.addEventListener("scroll", () => {
          const templateSetting = document.querySelector(".template-setting-pdf") as HTMLElement;

          if (templateSetting) {
            const scrollPosition = window.scrollY;

            if (scrollPosition > 80) {
              templateSetting.classList.add("show-fixed-header");
            } else {
              templateSetting.classList.remove("show-fixed-header")
            }
          }
        });
    
       
        return (
          <div className="page-conent-innere">
            <Page
              className="template-page-header"
              header={TEMPLATE_PAGE_HEADER}
              subtitle={GET_TEMPLATE_PAGE_SUBTITLE(name)}
            >
              <Prompt
                when={
                  !this.partialCleanCheck.isClean() &&
                  postingTemplate === undefined
                }
                message={UNSAVED_CHANGES_PROMPT}
              />
              {(!!loading || !!submitting) && <LinearProgress />}
              {/* {!isEditorMode && (
              <>
                <SurveyPrinter printSurveyRef={this.setPrintSurvey} />
                <Box marginBottom="1.5rem">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handlePrintClick}
                  >
                    {PRINT_BUTTON_LABEL}
                  </Button>
                </Box>
              </>
            )} */}
{console.log("isssmeess", isMeadSeason)}
              {!isEditorMode &&
                <div className="print-edit-template-btn">
                  <Button
                    style={{ marginRight: "20px" }}
                    variant="contained"
                    color="primary"
                    onClick={this.generatePDF}
                  >
                    {PRINT_BUTTON_LABEL}
                  </Button>
                  {isMeadSeason === false && 
                  <>
                  <Button
                    style={{ marginRight: "20px" }}
                    variant="contained"
                    color="primary"
                    onClick={this.checkCustomizableAddonAndRedirect}
                    // component={Link}
                    // {...({
                    //   to: `/${schoolSlug}/edit-template/${templateId}`,
                    // } as any)}
                  >
                    Edit Template
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.openDeleteModal()}
                  >
                    
                    RESTORE TEMPLATE
                  </Button>
                  </>
      }
                </div>
              }

              <Modal className="modal-delete-summary" open={modalVisible} closeModal={this.closeModal}>
                <Grid
                  style={{ height: "100%" }}
                  container={true}
                  direction="column"
                  justifyContent="space-between"
                >
                  <Grid>
                    <h2>Are you sure you want to restore this template?</h2>
                    <span>This action will replace the current content with the original template.</span>
                  </Grid>
                  <Grid container={true} justifyContent="space-between">
                    <Button onClick={this.closeModal} variant="contained">
                      Cancel
                    </Button>
                    <Button
                      onClick={this.restoreTemplate}
                      variant="contained"
                      color="secondary"
                    >
                      Restore
                    </Button>
                  </Grid>
                </Grid>
              </Modal>

              <div className="pdf-content-handle" style={{ paddingLeft: "10px", paddingRight: "10px" }} id="pdfContent">
      
                <Box display="block" flexDirection="column" gridGap="2.5rem">
                {isGeneratingPDF && (
    <div id="header" style={{ textAlign: 'center', marginBottom: '20px', display: isGeneratingPDF ? 'block' : 'none' }}>
      <img src={school} alt="School Logo" style={{ width: '100px', height: 'auto' }} /> 
      <h2>{name}</h2> 
      <p>These are the current questions loaded into your survey.</p> 
    </div>
  )}
                  {isEditorMode && isMeadSeason === false && (
                    <div className="template-setting-pdf">
                      <TemplateSettings
                        SaveButtonWithProps={() => (
                          <div className="upadate-save-template-btn">

                            {isEditorMode && 
                              <>

                                <Button
                                                                    style={{ marginRight: "20px",marginTop:"15px" }}
                                  variant="contained"
                                  color="primary"
                                  component={Link}
                                  {...({
                                    to: `/${schoolSlug}/survey/edit/${templateId}`,
                                  } as any)}
                                >
                                  Go Back
                                </Button>
                                <Button
                                className="restore-templatee-inner"
                                  variant="contained"
                                  color="primary"
                                  // onClick={this.restoreTemplate} // Call restoreTemplate on button click
                                  onClick={() => this.openDeleteModal()}
                                >
                                  RESTORE TEMPLATE
                                </Button>
                              </>}



                            <div className="save-update-btn-template">
                              <SaveButton
                                templateId={templateId}
                                submitTemplate={this.submitTemplate}
                                updateTemplate={this.updateTemplate}
                                canSubmit={this.canSubmit}
                                isClean={this.partialCleanCheck.isClean}
                              />
                            </div>
                          </div>
                        )}
                        name={name}
                        templates={templates}
                        templateId={templateId}
                        parentId={parentId}
                        copyId={copyId}
                        defaultPositiveText={defaultPositiveText}
                        defaultNegativeText={defaultNegativeText}
                        defaultReversed={defaultReversed}
                        defaultScale={defaultScale}
                        enableParentQuestions={enableParentQuestions}
                        scalePreview={scalePreview}
                        templateType={templateType}
                        parentTemplate={parentTemplate}
                        handleParentTemplateChange={this.handleParentTemplateChange}
                        handleTemplateTypeChange={this.handleTemplateTypeChange}
                        handleCopyTemplateChange={this.handleCopyTemplateChange}
                        handleEnableParentQuestions={this.handleEnableParentQuestions}
                        handleReversedChange={this.handleReversedChange}
                        handleScaleChange={this.handleScaleChange}
                        loadCopyQuestions={this.loadCopyQuestions}
                        handleNameChange={this.handleNameChange}
                        handleDefaultPositiveTextChange={
                          this.handleDefaultPositiveTextChange
                        }
                        handleDefaultNegativeTextChange={
                          this.handleDefaultNegativeTextChange
                        }
                        handleScalePreviewChange={this.handleScalePreviewChange}
                      />


                      {isEditorMode &&
                        <h3 className="heading-trans">Click on any box to edit the question, or use the delete button to remove it. Be sure to click "Update" once you’ve finished editing.</h3>
                      }

                    </div>

                  )}

                    <style>
                    {`
                      .padding-expection textarea,
                      .padding-expections textarea {
                          font-family: "Oswald", Arial, sans-serif !important;
                      }
                    
                    `}
                   </style>
     {/* ======================================              */}


                  <div>
                    <Typography
                      className={classes.questionCategoryHeading}
                      variant="h5"
                    >
                      {EXPECTATIONS_QUESTIONS_HEADING} (Scaled)
                    </Typography>
                  </div>
                  {(hasExpectationsQuestions || isEditorMode) && (
                    
                    
                      <div className="padding-expections" >


                      {hasExpectationsQuestions && (
                        <AthleteCoachHeading
                       isAdSurvey = {this.state.schoolData?.isAdSurvey }
                          classes={classes}
                          isEditorMode={isEditorMode}
                        />
                      )}
                      {this.renderQuestions(
                        expectationsQuestions,
                        TemplateQuestionCategory.expectations,
                        false
                      )}
                      {/* <div style={{ pageBreakAfter: 'always' }}/> */}
                    </div>

                  )}
     {/* ================== end ====================              */}
            {(hasWarmthQuestions || isEditorMode) && (
  <div className="padding-expection">
    {/* Heading + Pehla question ko ek saath group karo with break avoid */}
    <div style={{ 
      pageBreakInside: 'avoid', 
      breakInside: 'avoid',
      paddingBottom: "4px",
    }}>
      <Typography
        className={classes.questionCategoryHeading}
        variant="h5"
        style={{paddingTop: isGeneratingPDF ? "25px" : ""}}
      >
        {WARMTH_QUESTIONS_HEADING} (Scaled) 
      </Typography>
      
      {hasWarmthQuestions && (
        <AthleteCoachHeading
          isAdSurvey={this.state.schoolData?.isAdSurvey}
          classes={classes}
          isEditorMode={isEditorMode}
        />
      )}
      
      {/* Sirf pehla question */}
      {warmthQuestions && warmthQuestions.length > 0 && 
        this.renderQuestions(
          [warmthQuestions[0]],
          TemplateQuestionCategory.warmth,
          false
        )
      }
    </div>
    
    {/* Baaki ke questions normal */}
    {warmthQuestions && warmthQuestions.length > 1 && 
      this.renderQuestions(
        warmthQuestions.slice(1),
        TemplateQuestionCategory.warmth,
        false
      )
    }
  </div>
)}
{(hasOtherQuestions || isEditorMode) && (
  <div className="padding-expection">
    {/* Heading + Pehla question ko ek saath group karo with break avoid */}
    <div style={{ 
      pageBreakInside: 'avoid', 
      breakInside: 'avoid',
      paddingBottom: "4px",
    }}>
      <Typography
        className={classes.questionCategoryHeading}
        variant="h5"
                style={{paddingTop: isGeneratingPDF ? "25px" : ""}}

      >
        {WRITTEN_QUESTIONS_HEADING} (Written)
      </Typography>
      
      {hasOtherQuestions && (
        <AthleteCoachHeading
          isAdSurvey={this.state.schoolData?.isAdSurvey}
          classes={classes}
          isEditorMode={isEditorMode}
        />
      )}
      
      {/* Sirf pehla question */}
      {otherQuestions && otherQuestions.length > 0 && 
        this.renderQuestions(
          [otherQuestions[0]],
          TemplateQuestionCategory.other,
          false
        )
      }
    </div>
    
    {/* Baaki ke questions normal */}
    {otherQuestions && otherQuestions.length > 1 && 
      this.renderQuestions(
        otherQuestions.slice(1),
        TemplateQuestionCategory.other,
        false
      )
    }
  </div>
)}

                 {(hasParentQuestions || isEditorMode) && (
  <div className="padding-expection">
    {/* Heading + Pehla question ko ek saath group karo with break avoid */}
    <div style={{ 
      pageBreakInside: 'avoid', 
      breakInside: 'avoid',
      paddingBottom: "4px",
    }}>
      {/* Show heading only if parent questions are available */}
      {parentCategoryQuestions && parentCategoryQuestions.length > 0 && (
        <Typography
          className={classes.questionCategoryHeading}
          variant="h5"
          style={{paddingTop: isGeneratingPDF ? "25px" : ""}}
        >
          {PARENT_QUESTIONS_HEADING}
        </Typography>
      )}
      
      {/* Sirf pehla question */}
      {parentCategoryQuestions && parentCategoryQuestions.length > 0 && 
        this.renderQuestions(
          [parentCategoryQuestions[0]],
          TemplateQuestionCategory.parent,
          true
        )
      }
    </div>
    
    {/* Baaki ke questions normal */}
    {parentCategoryQuestions && parentCategoryQuestions.length > 1 && 
      this.renderQuestions(
        parentCategoryQuestions.slice(1),
        TemplateQuestionCategory.parent,
        true
      )
    }
  </div>
)}
                </Box>
              </div>
            </Page>
          </div>
        );
      }
      private loadUserSubscription = async (schoolId: any) => {
         const userSubscription: any = await this.buildGet(
              this,
              `payment/getOneHistory/${schoolId}`
            )();
            console.log("userSubscription API Response:", userSubscription);
            if (userSubscription?.status) {
              this.setState((prevState) => ({
                ...(prevState as any),
                userSubscription: userSubscription?.data,    
              }));
            }
      };

      private openDeleteModal = () => {
        this.setState((prevState) => ({
          ...(prevState as any), // Type assertion to bypass type checking
          modalVisible: true,    // Set modalVisible to true to open the modal
        }));
      };

      private closeModal = () => {
        this.setState((prevState) => ({
          ...(prevState as any), // Type assertion to bypass type checking
          modalVisible: false,   // Set modalVisible to false to close the modal
        }));
      };
      
      // private readonly handlePrintClick = () => {
      //   if (this.printEvaluation === undefined) {
      //     throw new Error("There is not print");
      //   }
      //   const { parentId } = this.state;
      //   this.printEvaluation(parentId ?? NaN);
      // };

      // private readonly setPrintSurvey = (
      //   printEvaluation: PrintSurveyFunc | null
      // ) => {
      //   this.printEvaluation = printEvaluation ?? undefined;
      //   this.setState({ showPrintButton: !!this.printEvaluation });
      // };

      private handleParentTemplateChange = async (
        e: React.ChangeEvent<HTMLSelectElement>
      ) => {
        const parentId =
          e.target.value === noneIdValue ? null : parseInt(e.target.value, 10);
        this.loadParentQuestions(parentId);
        this.setState({ parentId });
      };

      private handleTemplateTypeChange = async (
        e: React.ChangeEvent<HTMLSelectElement>
      ) => {
        const templateType = Number(e.target.value);
        this.setState({ templateType });
      };

      private handleCopyTemplateChange = async (
        e: React.ChangeEvent<HTMLSelectElement>
      ) => {
        const copyId =
          e.target.value === noneIdValue ? null : parseInt(e.target.value, 10);
        this.setState({ copyId });
      };

      private handleEnableParentQuestions = async (
        e: React.ChangeEvent<HTMLInputElement>
      ) => this.setState({ enableParentQuestions: e.target.checked });

      private handleReversedChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        this.setState({ defaultReversed: e.target.checked });

      private handleScaleChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
        this.setState({ defaultScale: parseInt(e.target.value, 10) });

      private loadCopyQuestions = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loading: true,
          },
          {
            loading: undefined,
          },
          async () => {
            // const { copyId } = this.state;
            // if (copyId !== null) {
            //   const { questions } = await this.buildGet<ITemplate>(
            //     this,
            //     `template/${copyId}`
            //   )();
            //   this.setState((prevState) => {
            //     const newState = {
            //       questions: prevState.questions.concat(
            //         questions
            //           .filter((q) => q.templateId === copyId)
            //           .map((q) => ({
            //             ...q,
            //             deleted: undefined,
            //             id: -1,
            //             localId: this.questionLocalId++,
            //             templateId: -1,
            //           }))
            //       ),
            //     };
            //     this.partialCleanCheck.setOldFormData(newState);
            //     return newState;
            //   });
            // }
          },
          () => {
            this.setState({ loading: undefined });
          }
        );

      private loadParentQuestions = (templateId: number | null) =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loading: true,
          },
          {
            loading: undefined,
          },
          async () => {
            if (templateId === null) {
              // If we don't have an parent id set, don't make the request
              this.setState({ parentQuestions: [] });
            } else {
              this.setState({
                parentQuestions: (
                  await this.buildGet<ITemplate>(
                    this,
                    `school/template/${templateId}`
                  )()
                ).questions,
              });
            }
          },
          () => {
            this.setState({ loading: undefined });
          }
        );

      // private loadInheritTemplates = () =>
      //   void this.runCancellableStatefulAsync(
      //     this,
      //     {
      //       loading: true,
      //     },
      //     {
      //       loading: undefined,
      //     },
      //     async () => {
      //       this.setState({
      //         templates: await this.buildGet<ITemplate[]>(this, "template")(),
      //       });
      //     },
      //     () => {
      //       this.setState({ loading: undefined });
      //     }
      //   );

      private loadTemplate = (templateId: number | undefined) =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loading: true,
          },
          {
            loading: undefined,
          },
          async () => {
            if (templateId !== undefined) {
              const {
                defaultNegativeText,
                defaultPositiveText,
                defaultReversed,
                defaultScale,
                enableParentQuestions,
                parentId,
                name,
                questions,
                type,
                school
              } = await this.buildGet<ITemplate  & { school?: { id: number; name: string; location: string, logo1: string } }>(
                this,
                `school/template/${templateId}`
              )();
              this.setState((prevState) => {
                const newState = {
                  defaultNegativeText,
                  defaultPositiveText,
                  defaultReversed,
                  defaultScale,
                  enableParentQuestions,
                  name,
                  parentId,
                  // Questions also include inherited questions, and to keep things simple, just filter them out and load them again seperately
                  questions: questions
                    .map((q) => ({
                      ...q,
                      deleted: undefined,
                      localId: this.questionLocalId++,
                    })),
                  templateType: type,     
                };
                this.setState((prevState) => ({
                  ...(prevState as any), 
                  school: school?.logo1,   
                }));
                this.partialCleanCheck.setOldFormData(newState);
                return newState;
              });
              this.loadParentQuestions(templateId);
            }
          },
          () => {
            this.setState({ loading: undefined });
          }
        );

      private submitTemplate = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            postingTemplate: true,
            submitting: true,
          },
          {
            postingTemplate: undefined,
            submitting: undefined,
          },
          async () => {
            const {
              parentId,
              name,
              questions,
              defaultNegativeText,
              defaultPositiveText,
              defaultReversed,
              defaultScale,
              enableParentQuestions,
              templateType,
            } = this.state;
            await this.buildPost<ITemplateData, void>(
              this,
              "template"
            )({
              defaultNegativeText,
              defaultPositiveText,
              defaultReversed,
              defaultScale,
              enableParentQuestions,
              name,
              parentId,
              questions,
              type: templateType,
            });
            await this.props.history.push(`/admin/templates`);
            await this.loadTemplate(this.props.templateId);
          },
          () => {
            this.setState({
              postingTemplate: undefined,
              submitting: undefined,
            });
          }
        );

      private updateTemplate = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            submitting: true,
          },
          {
            submitting: undefined,
          },
          async () => {
            const { templateId, schoolId, schoolSlug } = this.props;
            console.log("slug", schoolSlug)
            const {
              parentId,
              name,
              questions,
              defaultPositiveText,
              defaultNegativeText,
              defaultReversed,
              defaultScale,
              enableParentQuestions,
              templateType,
            } = this.state;
            if (schoolId === undefined) {
              // No school Id means we are in the admin view
              await this.buildPut<ITemplateData, void>(
                this,
                `admin/template/${templateId}`
              )({
                defaultNegativeText,
                defaultPositiveText,
                defaultReversed,
                defaultScale,
                enableParentQuestions,
                name,
                // idk how parentId ever gets set to a string. It happends when the template is loaded from the server, but everything looks like type of number
                // the parentId was a bigint in the database
                parentId,
                // Filter out local questions that have been deleted
                questions: questions.filter(
                  (q) => !(q.id === -1 && q.deleted === true)
                ),
                type: templateType,
              });
            } else {
              // School Id means we are in the director view
              // `school/template/${templateId}` //  added school here for director view its working in case of deleting ques
              await this.buildPut<ITemplateDirectorRequest2, void>(
                this,
                `school/template/${templateId}`
              )({
                defaultNegativeText,
                defaultPositiveText,
                defaultReversed,
                defaultScale,
                enableParentQuestions,
                name,
                parentId: null,
                questions: questions.filter(
                  (q) => !(q.id === -1 && q.deleted === true)
                ),
                schoolId,
                type: templateType,
              });
            }
            await this.loadTemplate(this.props.templateId);
          },
          () => {
            this.setState({ submitting: undefined });
          }
        );

      private restoreTemplate = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            submitting: true,
          },
          {
            submitting: undefined,
          },
          async () => {
            const { templateId, schoolId } = this.props;
            // Check if schoolId is defined
            if (schoolId === undefined) {
              console.error('School ID is required but is undefined.');
              this.setState({ submitting: undefined });
              return;
            }

            try {
              // Making a PUT request to restore the template based on the given API structure
              await this.buildPut<{ schoolId: number }, void>(
                this,
                `school/templateRestore/${templateId}`
              )({
                schoolId,
              });
              this.closeModal();
              await this.loadTemplate(templateId);
            } catch (error) {
              console.error('Error restoring template:', error);
              // Handle error if needed
            }

            // Resetting the submitting state
            this.setState({ submitting: undefined });
          },
          () => {
            this.setState({ submitting: undefined });
          }
        );


      private handleScalePreviewChange = (
        e: React.ChangeEvent<{}>,
        value: string
      ) =>
        this.setState({
          scalePreview: value,
        });

      private handleQuestionChangeTextArea =
        (question: ITemplateQuestionEdit, field: string) =>
          (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            const value = e.target.value;
            this.setState((prevState) =>
              update(prevState, {
                questions: {
                  [prevState.questions.indexOf(question)]: {
                    [field]: { $set: value },
                  },
                },
              })
            );
          };

      // private handleQuestionChangeInputElement =
      //   (question: ITemplateQuestionEdit, field: string) =>
      //     (e: React.ChangeEvent<HTMLInputElement>) => {
      //       const value =
      //         e.target.type === "checkbox" ? e.target.checked : e.target.value;
      //       this.setState((prevState) =>
      //         update(prevState, {
      //           questions: {
      //             [prevState.questions.indexOf(question)]: {
      //               [field]: { $set: value },
      //             },
      //           },
      //         })
      //       );
      //     };

      // private handleQuestionChangeSelectElement =
      //   (question: ITemplateQuestionEdit, field: string) =>
      //     (e: React.ChangeEvent<HTMLSelectElement>) => {
      //       const value = e.target.value;
      //       this.setState((prevState) =>
      //         update(prevState, {
      //           questions: {
      //             [prevState.questions.indexOf(question)]: {
      //               [field]: { $set: parseInt(value, 10) },
      //             },
      //           },
      //         })
      //       );
      //     };

      private handleQuestionTypeChange =
      (question: ITemplateQuestionEdit) =>
      (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = parseInt(e.target.value, 10);
        this.setState((prevState) => {
          // Update the type of the specific question
          const questionIndex = prevState.questions.indexOf(question);
          const updatedQuestions = update(prevState.questions, {
            [questionIndex]: {
              type: { $set: value },
            },
          });
    
          // Adjust the order if the new type is 'written' to move it after the last existing 'written' question
          if (value === TemplateQuestionType.written) {
            const maxWrittenOrder = Math.max(
              0,
              ...updatedQuestions
                .filter((q) => q.type === TemplateQuestionType.written && q.localId !== question.localId)
                .map((q) => q.order)
            );
            updatedQuestions[questionIndex].order = maxWrittenOrder + 1;
          }
    
          const sortedQuestions = updatedQuestions.sort((a, b) => {
            if (a.type === TemplateQuestionType.scale && b.type !== TemplateQuestionType.scale) {
              return -1; // 'scale' type moves up
            }
            if (a.type !== TemplateQuestionType.scale && b.type === TemplateQuestionType.scale) {
              return 1; // 'written' type stays below 'scale'
            }
            if (a.type === TemplateQuestionType.written && b.type === TemplateQuestionType.written) {
              return a.order - b.order; // Maintain order for 'written'
            }
            return 0; // Maintain position otherwise
          });
    
          return { questions: sortedQuestions };
        }, () => {
          // Focus on the textarea if it exists
          if (this.newQuestionRef.current) {
            this.newQuestionRef.current.focus();
          }
        });
      };
    
      // private setToDefault =
      //   (question: ITemplateQuestionEdit) =>
      //     (e: React.MouseEvent<HTMLButtonElement>) => {
      //       const {
      //         defaultNegativeText,
      //         defaultPositiveText,
      //         defaultReversed,
      //         defaultScale,
      //       } = this.state;
      //       this.setState((prevState) =>
      //         update(prevState, {
      //           questions: {
      //             [prevState.questions.indexOf(question)]: {
      //               scaleNegativeText: { $set: defaultNegativeText },
      //               scalePositiveText: { $set: defaultPositiveText },
      //               scaleReversed: { $set: defaultReversed },
      //               scaleScale: { $set: defaultScale },
      //             },
      //           },
      //         })
      //       );
      //     };

      private handleNewQuestion =
        (category: TemplateQuestionCategory) => () => {
          const {
            defaultNegativeText,
            defaultPositiveText,
            defaultScale,
            defaultReversed,
          } = this.state;
          const questionCategory = this.getQuestionCategory(category);
          const order = (() => {
            const lastQuestion = questionCategory[questionCategory.length - 1];
            if (lastQuestion !== undefined) {
              return lastQuestion.order + 1;
            }
            return 0;
          })();
          const question: ITemplateQuestionEdit = {
            category,
            coachText: "",
            id: -1,
            localId: this.questionLocalId++,
            order,
            parentText: "",
            scaleNegativeText: defaultNegativeText,
            scalePositiveText: defaultPositiveText,
            scaleReversed: defaultReversed,
            scaleScale: defaultScale,
            studentText: "",
            templateId: -1,
            status: false,
            type: category === 0 || category === 1 ? 0
                : category === 2 ? 1
                : TemplateQuestionType.scale,
          };
      
          this.setState(
            (prevState) => {
              // Add the new question to the questions array
              const updatedQuestions = [...prevState.questions, question];
      
              // Sort only if the category matches the "parent" category
              const sortedQuestions =
                category === TemplateQuestionCategory.parent
                  ? updatedQuestions.sort((a, b) => {
                      if (
                        a.type === TemplateQuestionType.scale &&
                        b.type !== TemplateQuestionType.scale
                      ) {
                        return -1; // Move 'scale' type to the top
                      }
                      if (
                        a.type !== TemplateQuestionType.scale &&
                        b.type === TemplateQuestionType.scale
                      ) {
                        return 1; // Keep 'written' type at the bottom
                      }
                      return 0; // No change if types are the same
                    })
                  : updatedQuestions; // No sorting for non-parent categories
      
              return { questions: sortedQuestions };
            },
            () => {
              // Focus on the new question's textarea after state is updated
              if (this.newQuestionRef.current) {
                this.newQuestionRef.current.focus();
              }
            }
          );
        };
      
      private handleQuestionDeleteToggle =
        (question: ITemplateQuestionEdit) => () => {
          // We need to update the order on all the questions after the deleted question
          const deleted = (() => {
            const d =
              question.deleted === undefined || question.deleted === false;
            return d ? true : undefined;
          })();
          // TODO Update the order property of all those behind the question
          // Mark the question as deleted
          this.setState((prevState) =>
            update(prevState, {
              questions: {
                [prevState.questions.indexOf(question)]: {
                  deleted: { $set: deleted },
                },
              },
            })
          );
        };

      // private toggleShowScaleOptions =
      //   () => (e: React.MouseEvent<HTMLElement>) => {
      //     this.setState((oldState) => ({
      //       questions: oldState.questions.map((question) => ({ ...question })),
      //       showScaleOptions: !oldState.showScaleOptions,
      //     }));
      //   };

      private handleOrderChange =
        (category: TemplateQuestionCategory) => (sort: SortEnd) => {
          // find the index of the category
          const categoryIndex = this.state.questions.findIndex(
            (q) => q.category === category
          );
          // Re-order the current question category
          this.setState({
            questions: arrayMove(
              this.state.questions,
              categoryIndex + sort.oldIndex,
              categoryIndex + sort.newIndex
            ).map((q, i) => {
              return Object.assign(q, { order: i });
            }),
          });
        };

        private renderQuestions(
          questions: ITemplateQuestionEdit[],
          category: TemplateQuestionCategory,
          parentSection: boolean
        ) {
          const { isEditorMode } = this.props;
          const userSubscription = (this.state as any).userSubscription;
          const isGeneratingPDF = (this.state as any).isGeneratingPDF;
          const isMeadSeason = (this.state as any).isMeadSeason;
          const isAdSurvey = (this.state as any).schoolData?.isAdSurvey;
          const validPlans = [4, 5];
          const isValidPlan = validPlans.includes(userSubscription?.plans?.id);
          const hasParentSurveyAddon = userSubscription?.addon?.some(
            (addon: any) => addon.addon?.id === 2
          ) || isValidPlan;
        
          // Sort questions to ensure scaled questions appear first and written at the bottom
          const sortedQuestions = [...questions].sort((a, b) => {
            if (a.type === TemplateQuestionType.scale && b.type !== TemplateQuestionType.scale) {
              return -1; // Place scale questions at the top
            }
            if (a.type !== TemplateQuestionType.scale && b.type === TemplateQuestionType.scale) {
              return 1; // Place non-scale questions below scale questions
            }
            if (a.type === TemplateQuestionType.written && b.type !== TemplateQuestionType.written) {
              return 1; // Place written questions at the bottom
            }
            if (b.type === TemplateQuestionType.written && a.type !== TemplateQuestionType.written) {
              return -1; // Ensure non-written questions are above written ones
            }
            return 0; // Maintain relative order if types are the same
          });
        
          return (
            <Box>
              {isEditorMode && (
                <>
                  {/* Pass sorted questions to SortableList to ensure 'scale' questions are at the top */}
                  {/* <SortableList
                    renderItem={this.renderQuestion}
                    items={sortedQuestions} 
                    onOrderChange={this.handleOrderChange(category)}
                  /> */}
                     {sortedQuestions.length > 0 && (
                    <SortableList
                      renderItem={this.renderQuestion}
                      items={sortedQuestions}
                      onOrderChange={this.handleOrderChange(category)}
                    />
                  )}
        
                  {/* Conditionally render 'renderNewQuestion' for parent section when add-on is present, during midseason, or for AD survey */}
                  {(() => {
                    console.log("====START Button Display Logic ====");
                    // console.log("category:", category);
                    // console.log("parentSection:", parentSection);
                     console.log("isEditorMode:", isEditorMode);
                     console.log("hasParentSurveyAddon:", hasParentSurveyAddon);
                     console.log("isMeadSeason:", isMeadSeason);
                     console.log("isAdSurvey:", isAdSurvey);
                    // console.log("sortedQuestions.length:", sortedQuestions.length);
                    // console.log("questions.length:", questions.length);
                    
                    // Calculate if button should show
                    // For non-parent sections: always show (when not 1 question)
                    // For parent sections: always show (when not 1 question) - removed all restrictions
                    const shouldShowForNonParent = !parentSection;
                    const shouldShowForParent = parentSection; // Always show for parent sections, no restrictions
                    console.log("DEBUG: shouldShowForParent calculation - parentSection:", parentSection, "result:", shouldShowForParent);
                    const shouldShow = shouldShowForNonParent || shouldShowForParent;
                    const shouldHideForSingleQuestion = sortedQuestions.length === 1;
                    const finalShouldShow = shouldShow && !shouldHideForSingleQuestion;
                    
                    // console.log("shouldShowForNonParent:", shouldShowForNonParent);
                    // console.log("shouldShowForParent:", shouldShowForParent);
                    // console.log("shouldShow:", shouldShow);
                    // console.log("shouldHideForSingleQuestion:", shouldHideForSingleQuestion);
                    // console.log("finalShouldShow:", finalShouldShow);
                    // console.log("Button will render:", finalShouldShow);
                    // console.log("====END Button Display Logic ====");
                    
                    return finalShouldShow ? (
                      <Box marginTop="1rem">{this.renderNewQuestion(category)}</Box>
                    ) : null;
                  })()}
                </>
              )}
              {!isEditorMode && (
                <Box
                  display="flex"
                  flexDirection="column"
                  gridGap="0.25rem"
                  borderRadius="0.5rem"
                  overflow="hidden"
                >
                  {sortedQuestions.map((question) => (
                    <Box 
                      key={question.id} 
                      className="question-box-print"
                      style={{ 
                        pageBreakInside: 'avoid', 
                        breakInside: 'avoid',
                        paddingTop: isGeneratingPDF ? '25px' : '0px',
                      }}
                    >
                      {this.renderInheritQuestion(question, parentSection)}
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          );
        }     
               
      private renderNewQuestion(category: TemplateQuestionCategory) {
        return (
          <button onClick={this.handleNewQuestion(category)} className="btn-new-question" type="button">
            Add New{" "}
            {TemplateQuestionCategory[category].charAt(0).toUpperCase() +
              TemplateQuestionCategory[category].slice(1)}{" "}
            Question
          </button>
        );
      }

      private renderQuestion = (question: ITemplateQuestionEdit) => {
        const { classes, isEditorMode } = this.props;
        const {isMeadSeason} = this.state;
        const isNewQuestion = question.id === -1;
                // if paln elite or premier then parent survey editable in that case also or if i don't have any plan but have addon of parent survey then also editable
        const userSubscription = (this.state as any).userSubscription;
        const validPlans = [4, 5];
          const isValidPlan = validPlans.includes(userSubscription?.plans?.id);
          const hasParentSurveyAddon = userSubscription?.addon?.some(
            (addon: any) => addon.addon?.id === 2
          ) || isValidPlan;

          console.log(question, "questionITemplateQuestionEdit")

        return (
          <>
          {isMeadSeason === false && 
          <div className="grid-border-head">
            <Grid container={true}>
              <Grid
                container={true}
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
              >
                {/* <Grid item={true}>
                <this.DragHandle />
              </Grid>
               */}

              </Grid>
              <div className="head-templage-display-edit">
                <Grid className={classes.templatedashcapital} container={true} justifyContent="flex-start" spacing={1}>
                  <div className="d-flex template-display-edit-form">
                   
                    {question.category !== TemplateQuestionCategory.parent && (
                      <>
                        <Grid item={true} xs={3}  >
                          <textarea
                            style={{
                              backgroundColor: question.deleted ||  question.status
                                ? "rgba(73, 75, 143, 0.15)" // Lighter background color for blur effect
                                : "rgba(73, 75, 143, 0.15)", // Original background color
                              filter: question.deleted || question.status ? "opacity(0.5)" : "none", // Apply blur effect when deleted
                            }}
                            rows={3}
                            onChange={this.handleQuestionChangeTextArea(
                              question,
                              "studentText"
                            )}
                            placeholder="Enter student text"
                            value={question.studentText}
                            className={classes.textArea}
                            disabled={question.deleted || question.status} // disable text on delete
                          />
                        </Grid>
                        <Grid style={{ width: "100%" }} item={true} xs={3}>
                          <textarea
                            style={{
                              width: "100%",
                              backgroundColor: question.deleted || question.status
                                ? "rgba(236, 78, 32, 0.15)" // Lighter background color for blur effect
                                : "rgba(236, 78, 32, 0.15)", // Original background color
                              filter: question.deleted || question.status ? "opacity(0.5)" : "none", // Apply blur effect when deleted
                            }}

                            rows={3}
                            onChange={this.handleQuestionChangeTextArea(
                              question,
                              "coachText"
                            )}
                            placeholder="Enter coach text"
                            value={question.coachText}
                            className={classes.textArea}
                            disabled={question.deleted || question.status}  // disable text on delete
                          />
                        </Grid>
                      </>
                    )}

{question.category === TemplateQuestionCategory.parent  && 
                    <>
                    {question.type === 1  ?
                     <div className="witten-scale-qure"><h5>(Written) </h5></div>: 
                     <div className="witten-scale-qure"><h5>(Scaled)</h5></div>}
                    </>
                     }
                  </div>
                  {question.category === TemplateQuestionCategory.parent && (
                    <div className="parents-text">
                      <Grid item={true} xs={3}>
                        <textarea
                        ref={isNewQuestion && question.localId === this.questionLocalId - 1 ? this.newQuestionRef : null}
                         style={{width:"100%",
                            backgroundColor: question.deleted || question.status
                              ? "rgba(73, 75, 143, 0.15)" // Lighter background color for blur effect
                              : "rgba(73, 75, 143, 0.15)", // Original background color
                            filter: question.deleted || question.status ? "opacity(0.5)" : "none", // Apply blur effect when deleted
                          }}
                          rows={3}
                          onChange={this.handleQuestionChangeTextArea(
                            question,
                            "parentText"
                          )}
                          placeholder="Enter parent text"
                          value={question.parentText}
                          className={classes.textArea}
                          disabled={question.deleted || hasParentSurveyAddon === false || question.status}  // disable text on delete
                        />
                      </Grid>
                    </div>
                  )}

                  {/* {question.deleted ? "" :
                    <Grid style={{width:"7%"}} container={true} justifyContent="flex-end">
                      <div style={{ position: 'relative', width: '45px', height: '40px', margin: "17px 0px 0px 27px" }}>
                        <button
                          style={{
                            width: '100%',
                            height: '100%',
                            // background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            // zIndex: 2, // Ensure this button is on top
                          }}
                          className="delete-btn"
                          onClick={this.handleQuestionDeleteToggle(question)}
                        >
                          <i className="fas fa-trash-alt" style={{ fontSize: '20px' }} />
                        </button>

                        <button
                          style={{
                            width: '100%',
                            height: '100%',
                            background: 'yellow', // Adjust this as needed
                            border: 'none',
                            cursor: 'pointer',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            zIndex: 1, // Lower than the icon button
                            opacity: 0, // Make the button invisible while still clickable
                          }}
                          onClick={this.handleQuestionDeleteToggle(question)}
                        />
                      </div>
                    </Grid>

                  } */}
                  
<Grid style={{ width: "7%" }} container={true} justifyContent="flex-end">
  {/* If the question is not deleted, show the delete button */}
  {question.status ? (
    <Tooltip
      title={
        <Typography style={{ fontSize: "14px", padding: "8px", display: "block", maxWidth: "250px" }}>
This question is locked to help your teacher and your department build staff Connectedness, Belonging, and a positive team culture. 
        </Typography>
      }
      placement="left"
      arrow={true}
    >
      <div
        style={{
          position: 'relative',
          width: '45px',
          height: '40px',
          margin: "17px 0px 0px 27px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <span style={{
          color: "#b71c1c",
          fontWeight: 600,
          fontSize: "15px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%"
        }}>
          <i className="fas fa-lock" style={{ fontSize: '25px', marginRight: 6, color: "#b71c1c" }} />
        </span>
      </div>
    </Tooltip>
  ) : (
    <>
      {question.deleted ? "" : (
        <div
          style={{
            position: 'relative',
            width: '45px',
            height: '40px',
            margin: "17px 0px 0px 27px",
          }}
        >
          {/* Show delete button for all questions except parent questions without the add-on */}
          {(question.category !== TemplateQuestionCategory.parent || hasParentSurveyAddon) ? (
            <button
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                left: 0,
                opacity: 1, // Ensure the icon remains visible
              }}
              className="delete-btn"
              onClick={hasParentSurveyAddon ? this.handleQuestionDeleteToggle(question) : undefined}  // Disable action if no add-on
            >
              <i className="fas fa-trash-alt" style={{ fontSize: '20px' }} />
            </button>
          ) : (
            // Invisible button for parent question without add-on to prevent interaction
            <button
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  position: 'absolute',
                  cursor: 'not-allowed',
                  top: 0,
                  left: 0,
                  opacity: 1, // Ensure the icon remains visible
                }}
                
         
              className="delete-btn"
            >
               <i className="fas fa-trash-alt" style={{ fontSize: '20px' }} />
               </button>
          )}

          {/* Invisible button on top to capture click for parent without add-on */}
          <button
            style={{
              width: '100%',
              height: '100%',
              background: 'transparent',
              border: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1,
              opacity: 0, // Invisible button
              pointerEvents: question.category === TemplateQuestionCategory.parent && !hasParentSurveyAddon ? 'none' : 'auto', // Disable clicks for parent without add-on
            }}
            onClick={this.handleQuestionDeleteToggle(question)}
          />
        </div>
      )}  
  </>
  )
    }
</Grid>
    
                </Grid>
              </div>


              {isEditorMode && isNewQuestion && question.category === TemplateQuestionCategory.parent &&
                <Grid item={true}>
                  <select
                    className="scale-select-inner"
                    onChange={this.handleQuestionTypeChange(question)}
                    defaultValue={question.type.toString()}
                  >
                    {[
                      TemplateQuestionType.scale,
                      TemplateQuestionType.written,
                    ].map((s: TemplateQuestionType) => (
                      <option key={s} value={s}>
                        {TemplateQuestionUtil.typeToString(s)}
                      </option>
                    ))}
                  </select>
                </Grid>
              }
              {/* <div className="border-scale">
                {(() => {
                  if (TemplateQuestionType.scale === question.type) {
                    const {
                      defaultNegativeText,
                      defaultPositiveText,
                      defaultReversed,
                      defaultScale,
                    } = this.state;
                    const notDefault = !(
                      question.scaleNegativeText === defaultNegativeText &&
                      question.scalePositiveText === defaultPositiveText &&
                      question.scaleReversed === defaultReversed &&
                      question.scaleScale === defaultScale
                    );




                    
    
                    const preview = (
                      <Grid style={{width:"100%"}} container={true} direction="row" alignItems="center">
                        <Box className={classes.radioPreview}>
                          <RadioScale
                            scale={question.scaleScale}
                            onChange={this.handleScalePreviewChange}
                            reversed={question.scaleReversed}
                            value={""}
                            positiveText={question.scalePositiveText}
                            negativeText={question.scaleNegativeText}
                          />
                        </Box>
                      </Grid>
                    );
                    const scalePropertyClass = notDefault
                      ? classes.scaleProperties
                      : classes.scalePropertiesDefault;
                    if (this.state.showScaleOptions) {
                      return (
                        <Box
                        style={{width:"100%",border:"1px solid #d9d9d4",padding:"15px"}}
                          className={`${scalePropertyClass} ${classes.scalePropertyDiv}`}
                        >
                          <button
                          className="hide-btn"
                            onClick={this.toggleShowScaleOptions()}
                            type="button"
                          >
                            Hide
                          </button>
                          <Box className="scale-select">
                            <label>
                            Scale:
                            </label>
                            <br/>
                            <select
                              onChange={this.handleQuestionChangeSelectElement(
                                question,
                                "scaleScale"
                              )}
                              value={question.scaleScale.toString()}
                            >
                              {range(1, 11).map((i) => (
                                <option key={i} value={i}>
                                  {i}
                                </option>
                              ))}
                            </select>
                          </Box>
                          <Box>
                            Reversed:{" "}
                            <input
                              checked={question.scaleReversed}
                              onChange={this.handleQuestionChangeInputElement(
                                question,
                                "scaleReversed"
                              )}
                              type="checkbox"
                            />
                          </Box>
                          <div className="posit-negat">
                          <div className="posive-innerr">
                          <label>
                          Positive Text:
                          </label><br/>
                          <textarea
                            rows={2}
                            value={question.scalePositiveText}
                            onChange={this.handleQuestionChangeTextArea(
                              question,
                              "scalePositiveText"
                            )}
                          />
                          </div>
                       <div className="negatie-inner">
                          <label>
                          Negative Text:
                          </label>
                          <br/>
                          <textarea
                            rows={2}
                            value={question.scaleNegativeText}
                            onChange={this.handleQuestionChangeTextArea(
                              question,
                              "scaleNegativeText"
                            )}
                          /> 
                          </div>
                          </div>
                          <br />
                          {notDefault ? (
                            <button
                            className="set-deafault-btn"
                             onClick={this.setToDefault(question)}>
                              Set to default
                            </button>
                          ) : null}
                          {preview}
                        </Box>
                      );
                    }
                    return (
                      <Box
                      style={{width:"100%",border:"1px solid #d9d9d4",padding:"15px"}}
                        className={`${scalePropertyClass} ${classes.scalePropertyDiv}`}
                      >
                        <button
                        className="hide-btn"
                          onClick={this.toggleShowScaleOptions()}
                          type="button"
                        >
                          Show
                        </button>
                        {preview}
                      </Box>
                    );
                  }
                  return null;
                })()}
                </div> */}
            </Grid>
          </div>
           }
  </>
        );
      };

      private renderInheritQuestion = (
        question: ITemplateQuestion,
        isParentSection: boolean
      ) => {
        const { classes } = this.props;
        return (
          <Box className={classes.questionRow}>
            <Box margin="0.5rem">
              {question.type === TemplateQuestionType.scale && (
                <RadioButtonChecked />
              )}
              {question.type === TemplateQuestionType.written && <Create />}
            </Box>
            <Box
              display="grid"
              gridTemplateColumns={isParentSection ? "1fr" : "1fr 1fr"}
              gridGap="1rem"
              width="100%"
            >
              {isParentSection && (
                <Typography
                  className={classNames([
                    classes.question,
                    classes.parentQuestion,
                  ])}
                  style={{ whiteSpace: "pre-wrap"}}
                >
                  {question.parentText}
                </Typography>
              )}
              {!isParentSection && (
                <>
                  <Typography
                  style={{ whiteSpace: "pre-wrap"}}
                    className={classNames([
                      classes.question,
                      classes.studentQuestion,
                    ])}
                  >
                    {question.studentText}
                  </Typography>
                  <Typography
                    style={{ whiteSpace: "pre-wrap"}}
                    className={classNames([
                      classes.question,
                      classes.coachQuestion,
                    ])}
                  >
                    {question.coachText}
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        );
      };

      private getQuestionCategory(
        category: TemplateQuestionCategory,
        questions = this.state.questions
      ) {
        return questions.filter((q) => q.category === category);
      }

      private canSubmit = () => {
        const { submitting, name, loading } = this.state;
        return name !== "" && submitting === undefined && loading !== true;
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/template-editor/TemplateEditorPage.tsx